/* @ngInject */
const wagonIcon = () => {
  const self = {}

  self.id = 'train'
  self.idNew = 'train'
  self.idValidate = 'assignment_turned_in'
  self.type = 'train'
  self.set = 'train'
  self.length = 'straighten'
  self.tare = 'train'
  self.capacity = 'train'
  self.feet = 'train'
  self.brakedMass = 'train'
  self.color = 'palette'
  self.step = ''
  self.revision = ''
  self.revisionDate = 'today'
  self.extendRevision = ''
  self.revisionDateExpired = 'today'
  self.isolated = ''
  self.damaged = ''
  self.isolatedComment = 'mode_edit'
  self.damagedComment = 'mode_edit'
  self.case = 'assignment'
  self.status = 'assignment'
  self.state = 'assignment'
  self.raadRaat = 'assignment'
  self.archive = 'assignment'
  self.client = 'assignment'
  self.elv = 'assignment'
  self.vt = 'assignment'
  self.comment = 'mode_edit'
  self.scrappingDate = 'today'
  self.saleDate = 'today'
  self.salePlace = 'my_location'
  self.dateIntervalBegin = 'today'
  self.dateIntervalEnd = 'today'
  self.commande = ''
  self.photo = 'picture_o'

  return self
}

export default wagonIcon



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/resources/icons.resource.js